import { Component, input } from '@angular/core';
import { AdvertViewModel } from '@models/advert/advert';
import { TranslateModule } from '@ngx-translate/core';
import { NumeralPipe } from '../../../pipes/numeral.pipe';

@Component({
    selector: 'advert-rooms-label',
    templateUrl: './advert-rooms-label.component.html',
    imports: [TranslateModule, NumeralPipe]
})
export class AdvertRoomsLabelComponent {
    readonly advert = input<AdvertViewModel>(undefined);
}
